let loadingRef;
let appRef;

export function extendLoadingScreen() {
    loadingRef = document.getElementById('loadingScreen');
    appRef = document.getElementById('app');
    if (loadingRef) loadingRef.id = 'updatedLoadingScreenId';
    if (appRef) appRef.style.display = 'none';
}

export function hideExtendedLoadingScreen() {
    if (!loadingRef) loadingRef = document.getElementById('updatedLoadingScreenId');
    if (!appRef) appRef = document.getElementById('app');
    loadingRef?.parentNode?.removeChild(loadingRef);
    appRef?.style?.removeProperty('display');
}
